import { matchPath, useHistory, useLocation } from 'react-router-dom';
import { StateSnapshot } from 'react-virtuoso';
import useSnapshotController from '../../../../../../../modules/catalogs/products/hooks/SnapshotController/useSnapshotController';
import PATHS from '../../../../../../routes.const';

const CATALOG_PRODUCTS_PATH = PATHS.main.catalogs.products.path;

const useBackToCatalogTrigger = () => {
  const history = useHistory();
  const { pathname } = useLocation();
  const { getActiveOrderSnapshot } = useSnapshotController<StateSnapshot>({
    isOfflineMode: false,
    mode: undefined,
  });

  const catalogSnapshot = getActiveOrderSnapshot();
  const isInCatalogScreen = !!matchPath(pathname, { path: CATALOG_PRODUCTS_PATH, exact: true });

  const goToCatalog = () => {
    if (!catalogSnapshot?.id) {
      return;
    }

    history.push({
      pathname: CATALOG_PRODUCTS_PATH.replace(':id', catalogSnapshot.id),
      search: catalogSnapshot.search,
    });
  };

  return {
    catalogName: catalogSnapshot?.name,
    isVisible: !!catalogSnapshot?.id && !isInCatalogScreen,
    goToCatalog,
  };
};

export default useBackToCatalogTrigger;
